import { createShallowStore, createStore } from '@frontend/store';

type PayerConnectionTabTypes = 'websites' | 'payers';

type InsurancePayerConnectionStore = {
  payerConnectionTab?: PayerConnectionTabTypes;
  setPayerConnectionTab: (tab: PayerConnectionTabTypes) => void;
  payerConnectionPayerID?: string;
  setPayerConnectionPayerID: (payerID: string) => void;
};

const useInsurancePayerConnectionStore = createStore<InsurancePayerConnectionStore>(
  (set) => ({
    payerConnectionTab: 'websites',
    payerConnectionPayerID: '',
    setPayerConnectionTab: (tab) => set((state) => ({ ...state, payerConnectionTab: tab })),
    setPayerConnectionPayerID: (payerID) => set((state) => ({ ...state, payerConnectionPayerID: payerID })),
  }),
  {
    name: 'insurancePayerConnectionStore',
  }
);

export const useInsurancePayerConnectionShallowStore = createShallowStore<InsurancePayerConnectionStore>(
  useInsurancePayerConnectionStore
);
